import {ReactNode} from "react"

import {useTheme} from "@/hooks/useTheme"

interface IProps {
    message: ReactNode
}

const BotMessage = ({message}: IProps) => {
    const {BotIcon} = useTheme()

    return (
        <div className="flex items-start justify-start m-[20px] mr-0 ml-0">
            <div className="mr-[10px]">{BotIcon}</div>
            <div className="bg-response rounded-2xl rounded-tl-none p-[20px] pt-[12px] pb-[12px] whitespace-pre-wrap">{message}</div>
        </div>
    )
}

export default BotMessage
